var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasPermission)?_c('v-chip',{class:{
    'eac-add-button': true,
    'loading-button': _vm.disabled,
  },attrs:{"label":!_vm.circular,"color":_vm.color || 'primary',"text-color":"white","disabled":_vm.disabled},on:{"click":function($event){!_vm.disabled ? _vm.$emit('action') : null}}},[_c('v-avatar',[_c('v-icon',[_vm._v(_vm._s(_vm.icon || "pending"))])],1),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }